import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import AppState from "./contaxt/AppState";
import { BrowserRouter as Router } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "../src/pages/multiLang/i18n";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer autoClose={2000} />
    <Router>

    <Provider store={store}>
    <AppState>
        
          <App />

    </AppState>

    </Provider>
    </Router>


  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
